let phoneResolution = false;
let safemargin = 0;

const tiers = [
    { max: 520, phone: true, margin: 0 }, // phones chicos/medianos
    { max: 768, phone: false, margin: 50 }, // tablet
    { max: 1366, phone: false, margin: 100 }, // laptop
    { max: Infinity, phone: false, margin: 150 } // desktop grande
];

const prefersCoarsePointer = () => window.matchMedia('(pointer: coarse)').matches;

function computeTier(w) {
    for (const t of tiers) if (w <= t.max) return t;
    return tiers[tiers.length - 1];
}

function applyState() {
    const w = window.innerWidth;
    const t = computeTier(w);

    phoneResolution = t.phone || prefersCoarsePointer();
    safemargin = t.margin;

    const safeWidth = w - safemargin;
    const root = document.documentElement;
    root.style.setProperty('--safe-margin', `${safemargin}px`);
    root.style.setProperty('--safe-width', `${safeWidth}px`);
    root.style.setProperty('--is-phone', phoneResolution ? '1' : '0');
}

let rAF = 0;
function onResize() {
    cancelAnimationFrame(rAF);
    rAF = requestAnimationFrame(applyState);
}

window.addEventListener('DOMContentLoaded', applyState, { once: true });
window.addEventListener('resize', onResize, { passive: true });

const mq = window.matchMedia('(pointer: coarse)');
if (mq.addEventListener) mq.addEventListener('change', applyState);

function isMobileViewport() {
    return window.innerWidth <= 768;
}
